import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const Report = ({ r, onDecide }) => (
  <li className="bg-white rounded-3xl border border-pink-100 p-4 space-y-3" data-testid={`secret-name-report-${r.id}`}>
    <p className="text-xs text-slate-400">{new Date(r.created_at).toLocaleString("de-DE")}</p>
    <p className="text-sm"><b>Melder:</b> <span data-testid={`secret-name-reporter-${r.id}`}>{r.reporter_name}</span> <span className="text-slate-400">({r.reporter_alias})</span></p>
    <p className="text-sm"><b className="text-rose-600">Soll Namen verraten haben:</b> <span data-testid={`secret-name-accused-${r.id}`}>{r.accused_name}</span> <span className="text-slate-400">({r.accused_alias})</span></p>
    <div className="max-h-72 overflow-y-auto space-y-1 rounded-2xl bg-slate-50 p-3 text-sm" data-testid={`secret-name-messages-${r.id}`}>
      {r.messages.length === 0 && <p className="text-slate-400">Keine Nachrichten.</p>}
      {r.messages.map((m, i) => (
        <p key={i} className={m.from === "accused" ? "text-rose-700" : "text-slate-600"}>
          <b>{m.from === "accused" ? r.accused_name : r.reporter_name}:</b> {m.text}{m.flagged && <span className="text-amber-600"> (ausgeblendet)</span>}
        </p>
      ))}
    </div>
    <div className="flex flex-wrap gap-2">
      <button onClick={() => onDecide(r.id, "dismiss")} data-testid={`secret-name-dismiss-${r.id}`} className="h-10 px-4 rounded-full bg-slate-100 text-sm font-bold">Nur ansehen, keine Sperre</button>
      <button onClick={() => onDecide(r.id, "ban")} data-testid={`secret-name-ban-${r.id}`} className="h-10 px-4 rounded-full bg-rose-500 text-white text-sm font-bold">{r.accused_name} für den Chat sperren</button>
    </div>
  </li>
);

export function SecretNameReportsAdmin() {
  const [d, setD] = useState(null);
  const load = () => api.get("/secretchat/admin/name-reports").then(({ data }) => setD(data)).catch(() => setD({ reports: [], banned: [] }));
  useEffect(() => { load(); }, []);
  const decide = async (id, action) => {
    if (action === "ban" && !window.confirm("Diesen Nutzer wirklich für den heimlichen Chat sperren?")) return;
    try { await api.post(`/secretchat/admin/name-reports/${id}/${action}`); toast.success(action === "ban" ? "Für den heimlichen Chat gesperrt" : "Meldung erledigt"); load(); } catch (e) { toast.error(formatErr(e)); }
  };
  const unban = async (uid) => {
    try { await api.post(`/secretchat/admin/unban/${uid}`); toast.success("Sperre aufgehoben"); load(); } catch (e) { toast.error(formatErr(e)); }
  };
  if (!d) return null;
  return (
    <div className="space-y-6 max-w-3xl" data-testid="secret-name-admin">
      {d.reports.length === 0 ? <p className="text-sm text-slate-400" data-testid="secret-name-empty">Keine offenen Meldungen „Name verraten“.</p>
        : <ul className="space-y-4">{d.reports.map((r) => <Report key={r.id} r={r} onDecide={decide} />)}</ul>}
      {d.banned.length > 0 && (
        <div className="space-y-2" data-testid="secret-name-banned">
          <p className="text-sm font-bold">Für den heimlichen Chat gesperrt</p>
          {d.banned.map((u) => (
            <div key={u.user_id} className="flex items-center justify-between gap-2 bg-white rounded-2xl border border-pink-100 px-4 py-2 text-sm">
              <span>{u.name}</span>
              <button onClick={() => unban(u.user_id)} data-testid={`secret-name-unban-${u.user_id}`} className="h-8 px-3 rounded-full bg-slate-100 text-xs font-bold">Sperre aufheben</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
